<template>
  <div class="video-model" v-if="visible" @click="closeVideo()">
    <div class="video-box">
      <div class="video-panel">
        <video x5-video-player-type="h5-page" x5-video-player-fullscreen="true" autoplay="" controls="true"
          class="video-mp4" src="@/assets/video/jwi.mp4">your browser does not support the video
          tag</video>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      visible: false
    }
  },

  methods: {
    openVideo () {
      this.visible = true
    },
    closeVideo () {
      this.visible = false
    }
  }
}
</script>

<style scoped>
  .video-model {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    background-color: #00000080;
    overflow: auto;
    outline: 0;
  }

  .video-box {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  .video-panel {
    width: 790px;
    height: 450px;
  }

  .video-mp4 {
    height: 100%;
    width: 100%;
    position: relative;
    z-index: 1;
  }
</style>
